import 'photoswipe/dist/photoswipe.css'

import React, { forwardRef, useImperativeHandle, useState, useRef, useEffect } from 'react'
import { Gallery, Item } from 'react-photoswipe-gallery'

const AppGallery = forwardRef((_, ref) => {

  const [photos, setPhotos] = useState([])
  const [mounted, setMounted] = useState(false)

  const dataSource = photos.map((url, i) => ({
    sourceId: i+1,
    original: url,
    thumbnail: url,
    width: 800,
    height: 600,
  }))

  const sourcesRef = useRef({})

  useImperativeHandle(ref, () => ({
    open: async (photos) => {
      setPhotos([])
      setMounted(false)
      await new Promise((resolve) => setTimeout(resolve, 0))
      setMounted(true)
      setPhotos(photos)
    }
  }))

  useEffect(() => {
    if (photos.length && mounted && sourcesRef.current && sourcesRef.current[0]) {
      sourcesRef.current[0]()
    }
  }, [photos, mounted])

  if (!photos.length) {
    return null
  }
  
  return (
    <Gallery withDownloadButton dataSource={dataSource}>
      {
        dataSource.map((item, i) => {
          return (
            <Item key={i} {...item}>
              {({ ref, open }) => {
                sourcesRef.current[i] = open
                return (
                  <img style={{display: 'none'}} ref={ref} src={item.original} alt='comment' onClick={open} />
                )
              }}
            </Item>
          )
        })
      }
    </Gallery>
  )
})

export default AppGallery